import { empresasByEgresadosApiCall } from "./../../../../axios/apiClient";
import { egresadosApiCall } from "./../../../../axios/apiClient";

const controller = "empleo";

export default {
    getEmpleosMe: async () => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await empresasByEgresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = empresasByEgresadosApiCall.handleCatch(error);
        }
        return response;
    },
    createEmpleo: async (data) => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await empresasByEgresadosApiCall.post(controller, method, data);
            response.message = apiResponse?.data;
        } catch (error) {
            response = empresasByEgresadosApiCall.handleCatch(error);
        }
        return response;
    },
    editEmpleo: async (data) => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await empresasByEgresadosApiCall.put(controller, method, data);
            response.message = apiResponse?.data;
        } catch (error) {
            response = empresasByEgresadosApiCall.handleCatch(error);
        }
        return response;
    },
    deleteEmpleoMe: async (id) => {
        let response = { success: true };
        const method = `me/${id}`;
        try {
            const apiResponse = await empresasByEgresadosApiCall.delete(controller, method);
            response.message = apiResponse?.data;
        } catch (error) {
            response = empresasByEgresadosApiCall.handleCatch(error);
        }
        return response;
    },
    getPostulacionesByEmpleo: async (id_empleo) => {
        let response = { success: true };
        const method = `postulaciones/${id_empleo}`;
        try {
            const apiResponse = await empresasByEgresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = empresasByEgresadosApiCall.handleCatch(error);
        }
        return response;
    },
    cambiarEstatusDePostulacion: async (data) => {
        let response = { success: true };
        const method = `postulacion_de_egresado`;
        try {
            const apiResponse = await empresasByEgresadosApiCall.patch(controller, method, data, method);
            response.message = apiResponse?.data;
        } catch (error) {
            response = empresasByEgresadosApiCall.handleCatch(error);
        }
        return response;
    },
    //Sólo para egresados
    getEmpleosNoAplicadosByEgredado: async () => {

        let response = { success: true };
        const method = `noAplicados`;
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    postularEgresadoAEmpleo: async (id_empleo) => {
        let response = { success: true };
        const method = `postularme/${id_empleo}`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method);
            response.message = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    }
}